import axios from "axios";

const getSchools = () => {
	return axios.get("/api/data/schools", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getBusRoutes = () => {
	return axios.get("/api/data/busroutes", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getBusStops = () => {
	return axios.get("/api/data/busstops", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getParkAndRides = () => {
	return axios.get("/api/data/parkandrides", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getHealthcare = () => {
	return axios.get("/api/data/healthcare", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getGroceryStores = () => {
	return axios.get("/api/data/grocerystores", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getWorship = () => {
	return axios.get("/api/data/worship", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getMarinas = () => {
	return axios.get("/api/data/marinas", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getHouses = () => {
	return axios.get("/api/data/houses", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getRestaurants = () => {
	return axios.get("/api/data/restaurants", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getDogParks = () => {
	return axios.get("/api/data/dogparks", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getIcons = () => {
	return axios.get("/api/data/icons", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getIconsToggle = () => {
	return axios.get("/api/data/iconstoggle", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getJobs = () => {
	return axios.get("/api/data/jobs", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getLibraries = () => {
	return axios.get("/api/data/libraries", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getTransportation = () => {
	return axios.get("/api/data/transportation", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getEntertainment = () => {
	return axios.get("/api/data/entertainment", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getChildcare = () => {
	return axios.get("/api/data/childcare", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
}; //getCulture

const getCulture = () => {
	return axios.get("/api/data/culture", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getTrails = () => {
	return axios.get("/api/data/trails", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};

const getNeighbourhoods = () => {
	return dispatch => {
		axios
			.get("/api/data/neighbourhoods", {
				headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
			})
			.then(res => {
				dispatch({ type: "SET_NEIGHBOURHOODS", payload: res.data });
			});
	};
};

const getParks = () => {
	return axios.get("/api/data/parks", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};
const getSports = () => {
	return axios.get("/api/data/sports", {
		headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
	});
};
const getNeighbourhoodsColours = () => {
	return dispatch => {
		axios
			.get("/api/data/colours", {
				headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
			})
			.then(res => {
				dispatch({ type: "SET_COLOURS", payload: res.data });
			});
	};
};

export {
	getSchools,
	getBusRoutes,
	getBusStops,
	getParkAndRides,
	getHealthcare,
	getGroceryStores,
	getHouses,
	getIcons,
	getIconsToggle,
	getJobs,
	getNeighbourhoods,
	getParks,
	getNeighbourhoodsColours,
	getWorship,
	getMarinas,
	getDogParks,
	getRestaurants,
	getSports,
	getLibraries,
	getTransportation,
	getEntertainment,
	getChildcare,
	getTrails,
	getCulture
};



// WEBPACK FOOTER //
// ./src/actions/Map/dataActions.js